"use client";

import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import { ListPriceFormData } from "@/components/screens/ListPriceFormPage/types";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { ListPriceFormPageMessages } from "@/messages/listPrice/list-price-form-page.messages";

import DetailsSection from "./components/detailsSection";
import ValuesSection from "./components/valuesSection";

type Props = {
  messages: ListPriceFormPageMessages;
  isLoading: boolean;
};

function ListPriceForm({ messages, isLoading }: Props) {
  const router = useNavigate();
  const { lang } = useLanguage();
  const { submitForm } = useFormikContext<ListPriceFormData>();

  return (
    <MDBox>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <MDBox height={"100%"}>
            <DetailsSection messages={messages} />
          </MDBox>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <MDBox height={"100%"}>
            <ValuesSection messages={messages} />
          </MDBox>
        </Grid>
      </Grid>

      <MDBox mt={2}>
        <Grid container spacing={3} alignItems="center">
          <Grid size={12}>
            <MDBox display="flex" justifyContent="flex-end" gap={2}>
              <MDButton
                variant="gradient"
                color="light"
                onClick={() => router(ROUTE_URLS.listPrice(lang))}
                isLoading={isLoading}
              >
                {messages.cancelButton}
              </MDButton>

              <MDButton variant="gradient" color="dark" onClick={submitForm} isLoading={isLoading}>
                {messages.updateButton}
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default ListPriceForm;
